export const dollarToCents = (amt) => {
  if (!amt) return 0;
  return parseFloat((amt * 100).toFixed(2));
};
